export type IndicatorStatus = "green" | "yellow" | "red";

export function classifyEar(dpoae: any[]): IndicatorStatus {
  const { ratio } = getEarStats(dpoae);

  if (ratio >= 0.7) return "green";
  if (ratio >= 0.4) return "yellow";
  return "red";
}

export function getEarStats(dpoae: any[]) {
  if (!dpoae || dpoae.length === 0) {
    return { passes: 0, total: 0, ratio: 0 };
  }

  const relevant = dpoae.filter(
    (x) => x.f2 >= 1000 && x.f2 <= 6000
  );

  const passes = relevant.filter(
    (x) =>
      x.snr >= 6 &&
      x.fiability >= 98 &&
      x.dp >= -10 
  ).length;

  const total = relevant.length;
  const ratio = total > 0 ? passes / total : 0;

  return { passes, total, ratio };
}


export function classifyBrain(result?: string | boolean | null): IndicatorStatus {
  if (result == null) return "yellow";

  const isRisk = String(result).toLowerCase() === "true";

  return isRisk ? "red" : "green";
}

export function classifyBrainFromScore(
  score: number | null,
  age: number,
  curves: any[]
): IndicatorStatus {
  if (score == null || !curves?.length) return "yellow";

  const avg = curves.find(c => c.id === 'promedio');
  const avgPlus = curves.find(c => c.id === 'promedio+1');

  const getY = (curve: any) => {
    const point = curve.data.find((p: any) => p.x === age);
    return point?.y;
  };

  const yAvg = getY(avg);
  const yAvgPlus = getY(avgPlus);

  if (yAvg == null || yAvgPlus == null) return "yellow";

  if (score < yAvg) return "green";
  if (score < yAvgPlus) return "yellow";
  return "red";
}